var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('h1',{staticClass:"page-headline"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }